import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginRelayComponent } from './login-relay/login-relay.component';
import { SsoRoutingModule } from './sso-routing.module';

@NgModule({
  imports: [CommonModule, SsoRoutingModule, LoginRelayComponent],
  exports: [LoginRelayComponent],
})
export class SsoModule {}
